import { useState, useContext, createContext, useRef } from 'react'
import {InputNumber, Form, Space, message} from 'antd'
import { EditOutlined } from '@ant-design/icons'

const maxNum = 99999
const floatNumControl = val =>
  val == (val - 0).toFixed(0) ? val : (val - 0).toFixed(2)
export const EditableContext = createContext(null)
export default function EditableCell({
  handleSave,
  editable,
  inputFormatter = val => val,
  children,
  dataIndex,
  record,
  title,
  isRs=false,
  ...restProps
}) {
  const [editing, setEditing] = useState(false)
  const inputRef = useRef(null)
  const form = useContext(EditableContext)
  const toggleEdit = () => {
    setEditing(!editing)
    form.setFieldsValue({
      [dataIndex]: record[dataIndex]
    })
  }
  const save = async () => {
    setEditing(false)
    try {
      const values = await form.validateFields()
      toggleEdit()
      handleSave({ ...record, ...values })
    } catch (errInfo) {
      console.log('Save failed:', errInfo)
    }
  }
  const newinputFormatter = (val)=>{
    if(dataIndex === 'actStock'){
      val = val && Math.abs(parseInt(val))
      if (val) {
        if(val > record.saleableStock){
          message.info('活动库存不能大于线上销售库存');
          return val
        }else{
          return val
        }
      } else {
        return ''
      }
    }else{
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (!reg.test(val)){
        return ''
      } else {
        if(val > record.salePrice){
          message.info('团购价格不能大于当前售价');
          return val
        }else{
          return val
        }
      }
    }
  }
  let childNode = children
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: '请输入正确的数据',
            pattern: /^[0-9]*[\.]?[0-9]*$/
          }
        ]}>
        <InputNumber
          ref={inputRef}
          formatter={(dataIndex === 'actStock' || dataIndex === 'actPrice') ? newinputFormatter : (val)=> inputFormatter(val, record)}
          max={maxNum}
          min={-maxNum}
          size='small'
          controls={false}
          parser={floatNumControl}
          onPressEnter={save}
          style={{ width: 60 }}
          onBlur={save}
        />
      </Form.Item>
    ) : (
      <div
        className='editable-cell-value-wrap'
        style={{
          paddingRight: 24
        }}
        onClick={toggleEdit}>
        <Space>
          <span>{children}</span>
          <EditOutlined />
        </Space>
      </div>
    )
  }
  return <td {...restProps}>{childNode}</td>
}
